import {
  JobData,
  PassportArrivalHistory,
  PassportData,
  PassportsTransactionData,
} from '@/types';
import {
  Core,
  PASSPORT,
  PASSPORT_JOBS,
  PASSPORTS_ARRIVALS,
  PASSPORTS_TRANSACTIONS,
} from '../Core';

class Passport extends Core {
  postPassport = async (search: string) =>
    this.get<PassportData>(PASSPORT(), { search });

  postPassportJobs = async (search: string) =>
    this.get<JobData[]>(PASSPORT_JOBS(), { search });

  postPassportTransactions = async (search: string) =>
    this.get<PassportsTransactionData[]>(PASSPORTS_TRANSACTIONS(), { search });

  getPassportArrivals = async (search: string) =>
    this.get<PassportArrivalHistory[]>(PASSPORTS_ARRIVALS(), { search });
}

export const passport = new Passport();
